
import { Observable } from "rxjs";
import { MapProvider } from "../domain/models/map-provider.model";

export abstract class MapProviderRepository {
    
  abstract getMapProviders(): Observable<MapProvider[]>;
  
}
